import React, { useEffect } from "react"
import Phaser from "phaser"
import GameUtero from "./scenes/game-utero"
import Gamepubertad from "./scenes/game-pubertad"
import GameFlujo from "./scenes/game-flujo"

import "./main.scss"
export default function Main({
                               isMobile = false,
                               pushGameData,
                               initialScene = "utero",
                             }) {
  var Main
  const DIMENTIONS = isMobile
    ? {
      Y: (window.innerHeight < 600 ? 600 : window.innerHeight) - 170,
      X: window.innerWidth < 320 ? 320 : window.innerWidth,
    }
    : {
      Y: (window.innerHeight < 600 ? 600 : window.innerHeight) - 200,
      X: window.innerWidth > 1000 ? 1000 : window.innerWidth,
    }
  var CONFIG = {
    type: Phaser.AUTO,
    width: DIMENTIONS.X,
    height: DIMENTIONS.Y,
    parent: "phaser-game",
    transparent: true,
    scene: [{ preload }, GameUtero, Gamepubertad, GameFlujo],
  }

  function preload() {
    // Pass props to init(props) Scene
    Main.scene.start(initialScene, { isMobile, endScene })
  }

  const nextScene = __sceneKey => {
    Main.scene.start(__sceneKey, { isMobile, endScene })
  }

  const endScene = __dataEndGame => {
    pushGameData(__dataEndGame, nextScene)
  }

  useEffect(() => {
    if (!Main) Main = new Phaser.Game(CONFIG)
  }, [])

  return (
    <div className="f-phaser">
      <div className="f-phaser__container" id="phaser-game">
        {Main}
      </div>
    </div>
  )
}
